var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('system-notification',{attrs:{"content":_vm.notificationContent,"show-checkbox":true,"dont-show-again":_vm.dontShowAgain},on:{"update:dontShowAgain":function($event){_vm.dontShowAgain=$event},"update:dont-show-again":function($event){_vm.dontShowAgain=$event},"close":_vm.closeModalNotification}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }